const reducer = (state, action) => {
    switch (action.type) {
        case 'set':
            return { ...state, ...action.payload };
        default:
            console.log(`Invalid action type: ${action.type} or payload: ${action.payload}`);
            return state;
    }
};

export default reducer;
